import React from "react";
import { QuoteContainer, Wrapper } from "../styles/components/Galleries/Global";
import { Image } from "../styles/components/Galleries/Transitional";

const QuoteImage = () => {
  return (
    <Wrapper>
      <QuoteContainer>
        <Image
          src="https://www.datocms-assets.com/40484/1701162098-quote-04-1.png"
          $desktop
        />
        <Image
          src="https://www.datocms-assets.com/40484/1701172678-04_quote_mobile.png"
          $mobile
        />
      </QuoteContainer>
    </Wrapper>
  );
};

export default QuoteImage;
